/**
 * Retelling 结果展示组件
 */
import React from 'react';
import { RetellingAnalysis } from '../../../db/shadowDb';

interface RetellingResultProps {
  analysis: RetellingAnalysis;
  onAddVocab?: (vocab: RetellingAnalysis['suggestedVocab'][0]) => void;
}

export function RetellingResult({ analysis, onAddVocab }: RetellingResultProps) {
  const {
    keyPoints,
    coverageScore,
    suggestedVocab,
    bandEstimate,
    overallFeedback,
  } = analysis;

  // 统计关键点覆盖情况
  const fullCount = keyPoints.filter((kp) => kp.coverage === 'full').length;
  const partialCount = keyPoints.filter((kp) => kp.coverage === 'partial').length;
  const missingCount = keyPoints.filter((kp) => kp.coverage === 'missing').length;

  return (
    <div className="retelling-result">
      {/* 头部：分数 */}
      <div className="result-header">
        <div className="result-score">{coverageScore}%</div>
        {bandEstimate && (
          <div className="result-band">Band {bandEstimate.toFixed(1)}</div>
        )}
      </div>

      {/* 总体反馈 */}
      <div className="result-section">
        <h4 className="result-section-title">总体评价</h4>
        <p className="result-feedback">{overallFeedback}</p>
      </div>

      {/* 关键点覆盖 */}
      <div className="result-section">
        <h4 className="result-section-title">
          关键点覆盖 ({fullCount}✓ / {partialCount}△ / {missingCount}✗)
        </h4>
        <div className="keypoints-list">
          {keyPoints.map((kp, index) => (
            <div key={index} className="keypoint-item">
              <div className={`keypoint-status ${kp.coverage}`}>
                {kp.coverage === 'full' ? '✓' : kp.coverage === 'partial' ? '△' : '✗'}
              </div>
              <div className="keypoint-content">
                <p className="keypoint-original">{kp.originalPoint}</p>
                {kp.userExpression && (
                  <p className="keypoint-user">你说: "{kp.userExpression}"</p>
                )}
                {kp.feedback && (
                  <p className="keypoint-feedback">{kp.feedback}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 词汇建议 */}
      {suggestedVocab.length > 0 && (
        <div className="result-section">
          <h4 className="result-section-title">词汇提升建议</h4>
          <div className="vocab-list">
            {suggestedVocab.map((vocab, index) => (
              <div key={index} className="vocab-item">
                <p className="vocab-word">{vocab.word}</p>
                {vocab.userAlternative && (
                  <p className="vocab-context">
                    你说: "{vocab.userAlternative}"
                  </p>
                )}
                <p className="vocab-suggestion">{vocab.suggestion}</p>
                {onAddVocab && (
                  <button
                    type="button"
                    className="vocab-add-btn"
                    onClick={() => onAddVocab(vocab)}
                  >
                    + 加入词汇卡
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
